module.exports = __webpack_public_path__ + "static/cennik-362709932c97bdddcc8586bea45b4634.pdf";